export const BUTTON_TAG_NAME = "button" as const;

export const BUTTON_VARIANTS = [
  "primary",
  "neutral",
  "destructive",
  "secondary",
  "ghost",
  "link",
] as const;

export const BUTTON_GROUP_TAG_NAME = "button-group" as const;

export const BUTTON_GROUP_ITEM_TAG_NAME = "button-group-item" as const;
